import { render, staticRenderFns } from "./subscriptions.vue?vue&type=template&id=38418bdb&scoped=true&"
import script from "./subscriptions.vue?vue&type=script&lang=js&"
export * from "./subscriptions.vue?vue&type=script&lang=js&"
import style0 from "./subscriptions.vue?vue&type=style&index=0&id=38418bdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38418bdb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardTitle,VFlex,VIcon,VLayout,VPagination,VSimpleTable,VSnackbar,VSpacer})
